<template>
  <div class="message-wrapper">
    <bread-crumb></bread-crumb>
    <div class="global-table-container">
      <a-tabs defaultActiveKey="1" @change="handleChangeTab">
        <a-tab-pane tab="工作消息" key="1"></a-tab-pane>
        <a-tab-pane tab="系统消息" key="2">Content of Tab Pane 2</a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleChangeTab() {},
  },
};
</script>
